module.exports = __webpack_public_path__ + "img/playstar.97dd8077.png";